import { z } from "zod";
export const TENANT_USER_ROLES = ["tenant_admin", "editor", "approver", "viewer"];
export const tenantUserRoleSchema = z.enum(TENANT_USER_ROLES);
export const tenantMemberSchema = z.object({
    id: z.uuid(), email: z.email(), status: z.enum(["pending", "active", "suspended", "revoked"]), roles: z.array(tenantUserRoleSchema), version: z.number().int().positive()
}).strict();
export const tenantInvitationViewSchema = z.object({
    id: z.uuid(), membershipId: z.uuid(), email: z.email(), state: z.enum(["creating", "active", "accepted", "expired", "revoked", "failed"]), expiresAt: z.iso.datetime({
        offset: true
    }), version: z.number().int().positive(), deliveryStatus: z.string().nullable(), isCurrent: z.boolean(), providerStatus: z.enum(["pending", "create_dispatched", "create_unknown", "recovery_required", "done"]).nullable()
}).strict();
export const tenantUsersWorkspaceSchema = z.object({
    members: z.array(tenantMemberSchema).max(100), invitations: z.array(tenantInvitationViewSchema).max(200), nextCursor: z.uuid().nullable(), writeEnabled: z.boolean()
}).strict();
//# sourceMappingURL=tenant-users.js.map